// Shared square Answer/Decline button style — first built for the Calls
// list (LiveCallCard.jsx), reused here so the incoming-call widget
// (CallWidget.jsx) uses the exact same look instead of a second, drifting
// copy. `tone` is the button's accent color (theme.palette.success.main /
// error.main); `filled` picks solid-fill (Answer/Join) vs outlined
// (Decline).
export const actionBtnSx = (tone, filled) => ({
  width: 34,
  height: 34,
  // No global box-sizing:border-box in this app (recurring gotcha) — without
  // this, an outlined button's 2px border adds 4px to ITS OWN physical size
  // on top of the shared width/height, so it and a borderless sibling are
  // never actually the same size even though they share this same sx.
  boxSizing: "border-box",
  borderRadius: "10px", // square, not circular
  bgcolor: filled ? tone : "transparent",
  color: filled ? "#fff" : tone,
  border: filled ? "none" : `2px solid ${tone}`,
  boxShadow: filled ? `0 1px 6px ${tone}66` : "none",
  "&:hover": { bgcolor: filled ? tone : `${tone}1a`, filter: filled ? "brightness(0.9)" : "none" },
});

export const actionIconBoxSx = { width: 18, height: 18, display: "flex", alignItems: "center", justifyContent: "center" };
